module.exports = __webpack_public_path__ + "img/RichWildeandtheTomeofInsanity.42486dbb.png";